import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Input, Button } from 'antd';
import Validator from '@/views/account/utils/formValidator';
import { GAForgotPasswordClickConfirm } from '@/views/account/ga/forgotPassword';

import '@/views/account/assets/forgotAndResetPassWordModal.scss';

const ForgotPasswordModalRender = ({
  form,
  submitting,
  codeCountDownTimeSec,
  handleClickGetCode,
  handleSubmitForgetPassword,
}) => {
  const { t } = useTranslation(['loginAndSignUp', 'common']);

  /**
   * 渲染验证码输入框的获取验证码按钮的方法
   * @returns 返回验证码输入框的获取验证码按钮
   */
  const renderGetCodeBtn = () => {
    return !codeCountDownTimeSec ? (
      <span className='text-primary' onClick={() => handleClickGetCode()}>
        {t('getCode')}
      </span>
    ) : (
      <span className='text-primary' style={{ cursor: 'not-allowed' }}>
        {codeCountDownTimeSec} s
      </span>
    );
  };

  return (
    <div className='forget-and-reset-cont p-md-4 p-0'>
      <h4 className='fw-bold mb-4'>{t('forgotPasswordTitle')}</h4>
      <Form
        layout='vertical'
        ref={form}
        validateTrigger='onBlur'
        name='forgot-password'
        className='w-100'
        onFinish={handleSubmitForgetPassword}
      >
        <Form.Item
          name='email'
          label={t('common:email')}
          rules={[
            {
              required: true,
              type: 'email',
              formName: 'forgot_password',
              validator: Validator.emailValidator,
            },
          ]}
        >
          <Input placeholder={t('common:email')} allowClear />
        </Form.Item>
        <Form.Item
          name='verification'
          label={t('common:verificationCode')}
          rules={[
            {
              required: true,
              formName: 'forgot_password',
              validator: Validator.emptyValidator,
            },
          ]}
        >
          <Input
            className='verification-input'
            placeholder={t('common:verificationCode')}
            addonAfter={renderGetCodeBtn()}
          />
        </Form.Item>
        <Form.Item className='mb-0'>
          <Button
            className='fs-6 fw-bolder submit-btn py-2'
            style={{ minWidth: '50%' }}
            type='primary'
            htmlType='submit'
            size='large'
            loading={submitting}
            onClick={GAForgotPasswordClickConfirm}
          >
            {t('verifyEmailBtn')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ForgotPasswordModalRender;
